import message from "components/CustomMessage";
import moment from "moment";
import React, { useCallback } from "react";
import AnyaAPI from "restAPI/AnyaAPI";

import ACButton from "ac-components/ac-button/ACButton";
import TrashIcon from "ac-components/ac-icons/TrashIcon";

interface SidebarHistoryProps {
  onHistorySelected: (historyId: string) => void;
  fetchChatHistory: (shouldUpdateChatId: boolean) => void;
  chatHistory: ChatHistoryItem[];
  chatId: string;
  createNewChat: () => void;
}
type ChatHistoryItem = {
  conversationId: string;
  title: string;
  createdAt: string;
  updatedAt: string;
  widgetId: string;
};

export default function AnyaSidebarHistory({
  fetchChatHistory,
  onHistorySelected,
  chatHistory,
  chatId,
  createNewChat,
}: SidebarHistoryProps) {
  const shownCategories = ["Recents", "Last Week", "Last Month", "Longer Ago"];

  const onDelete = useCallback(
    async (conversationId) => {
      const _onDelete = async (conversationId: string) => {
        try {
          await AnyaAPI.deleteAnyaConversationMessages(conversationId).promise;
          fetchChatHistory(false);
          createNewChat();

          message.success("Conversation Deleted");
        } catch (e) {
          console.log(e);
          message.error("Error while deleting conversation, Please try again.");
        }
      };

      _onDelete(conversationId);
      return;
    },
    [createNewChat, fetchChatHistory],
  );

  const sections = shownCategories.map((category) => {
    const messages = chatHistory?.filter((message) => {
      const updatedAt = new Date(message.updatedAt);
      switch (category) {
        case "Recents":
          return moment(updatedAt).isSameOrAfter(moment().subtract(1, "day"));
        case "Last Week":
          return (
            moment(updatedAt).isSameOrAfter(moment().subtract(1, "week")) &&
            moment(updatedAt).isBefore(moment().subtract(1, "day"))
          );
        case "Last Month":
          return (
            moment(updatedAt).isSameOrAfter(moment().subtract(1, "month")) &&
            moment(updatedAt).isBefore(moment().subtract(1, "week"))
          );
        case "Longer Ago":
          return moment(updatedAt).isBefore(moment().subtract(1, "month"));
        default:
          return false;
      }
    });
    messages?.sort(
      (a, b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf(),
    );
    if (messages !== undefined && messages.length > 0) {
      return { category, messages };
    }
    return {};
  });
  return (
    <div className="p-l overflow-y-auto h-100">
      {sections?.map((section, index) => (
        <div key={index}>
          <p className="text-sm" style={{ marginBlock: "15px", color: "gray" }}>
            {section.category}
          </p>
          {section.messages?.map((message, idx) => (
            <div
              key={idx}
              className={`conversation-item-box ${chatId !== message.conversationId ? "hoverable" : "selected"}`}
              style={{
                display: "flex",
                alignItems: "center",
                borderRadius: "2px",
                justifyContent: "space-between",
                margin: "3px",
              }}
              onClick={() => {
                onHistorySelected(message?.conversationId);
              }}
            >
              <p className="conversation-item text-sm" key={idx}>
                {message.title}
              </p>
              <ACButton
                className="history-deletion-button"
                type="outline"
                size="sm"
                style={{
                  backgroundColor: "white",
                  marginRight: "3px",
                  border: "1px solid #E7E9EE",
                }}
                iconOnly
                onClick={() => onDelete(message?.conversationId)}
              >
                <TrashIcon className="text-danger" />
              </ACButton>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
